"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainLinks = void 0;

var _react = _interopRequireDefault(require("react"));

var _useHeaderMenu = require("../useHeaderMenu");

var _MenuSolutions = require("./MenuSolutions");

var _MenuSimulation = require("./MenuSimulation");

var _MenuBusiness = require("./MenuBusiness");

var _UiComponents = require("./UiComponents");

var _core = require("@emotion/core");
/* eslint-disable max-lines-per-function */


var MainLinks = function MainLinks() {
  var _ref = (0, _useHeaderMenu.useHeaderMenu)(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      domain = _ref2$.domain,
      active = _ref2$.active,
      device = _ref2$.device,
      isCustomType = _ref2$.isCustomType,
      _ref2$2 = _ref2[1],
      propsActive = _ref2$2.propsActive,
      handleDispatchMenuEvents = _ref2$2.handleDispatchMenuEvents,
      close = _ref2$2.close;

  var linkListProps = {
    mobile: null,
    desktop: {
      onBlur: function onBlur(event) {
        var currentTarget = event.currentTarget;
        setTimeout(function () {
          if (!currentTarget.contains(document.activeElement)) {
            close();
          }
        }, 0);
      }
    }
  };

  var setMainLinkProps = function setMainLinkProps(_ref3) {
    var link = _ref3.link,
        analyticEventAction = _ref3.analyticEventAction;
    var propsWithLink = {
      as: 'a',
      href: "".concat(domain).concat(link)
    };
    var propsWithoutLink = {
      as: 'span'
    };
    var eventLabel = link ? "".concat(domain).concat(link) : '';
    return {
      mobile: {
        as: 'div'
      },
      desktop: _objectSpread(_objectSpread({
        tabIndex: '0'
      }, link ? propsWithLink : propsWithoutLink), {}, {
        onClick: function onClick() {
          return handleDispatchMenuEvents({
            action: analyticEventAction,
            label: eventLabel
          });
        }
      })
    };
  };

  var IconTypes = {
    mobile: _UiComponents.NavIcon.Right,
    desktop: _UiComponents.NavIcon.Down
  };
  var Icon = IconTypes[device] || null;
  var typoProps = {
    as: 'span',
    mobile: '2xl',
    desktop: 'md',
    weight: 'xs',
    isCustomType: isCustomType
  };
  return (0, _core.jsx)(_UiComponents.Container.Links, linkListProps[device], (0, _core.jsx)(_UiComponents.Container.LinkItem, propsActive('simulation'), (0, _core.jsx)(_UiComponents.Layout.Flex, setMainLinkProps({
    analyticEventAction: 'inbound links | simule seu crédito'
  })[device], (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0
  }, (0, _core.jsx)(_UiComponents.Typo.Item, typoProps, "Simule seu cr\xE9dito")), (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0,
    margin: 0
  }, Icon && (0, _core.jsx)(Icon, {
    open: propsActive('simulation').isActive
  }))), (0, _core.jsx)(_UiComponents.Container.DropdownWrapper, {
    isOpen: propsActive('simulation').isActive
  }, (0, _core.jsx)(_MenuSimulation.MenuSimulation, {
    isOpen: active === 'simulation'
  }))), (0, _core.jsx)(_UiComponents.Container.LinkItem, propsActive('solutions'), (0, _core.jsx)(_UiComponents.Layout.Flex, setMainLinkProps({
    analyticEventAction: 'inbound links | soluções'
  })[device], (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0
  }, (0, _core.jsx)(_UiComponents.Typo.Item, typoProps, "Solu\xE7\xF5es")), (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0
  }, Icon && (0, _core.jsx)(Icon, {
    open: propsActive('solutions').isActive
  }))), (0, _core.jsx)(_UiComponents.Container.DropdownWrapper, {
    isOpen: propsActive('solutions').isActive
  }, (0, _core.jsx)(_MenuSolutions.MenuSolutions, {
    isOpen: active === 'solutions'
  }))), (0, _core.jsx)(_UiComponents.Container.LinkItem, propsActive('business'), (0, _core.jsx)(_UiComponents.Layout.Flex, setMainLinkProps({
    link: '/beneficios',
    analyticEventAction: 'inbound links | empresas'
  })[device], (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0
  }, (0, _core.jsx)(_UiComponents.Typo.Item, typoProps, "Benef\xEDcios corporativos")), (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0
  }, Icon && (0, _core.jsx)(Icon, {
    open: propsActive('business').isActive
  }))), (0, _core.jsx)(_UiComponents.Container.DropdownWrapper, {
    isOpen: propsActive('business').isActive
  }, (0, _core.jsx)(_MenuBusiness.MenuBusiness, {
    isOpen: active === 'business'
  }))), (0, _core.jsx)(_UiComponents.Container.LinkItem, propsActive('help'), (0, _core.jsx)(_UiComponents.Layout.Flex, {
    as: "a",
    href: "https://ajuda.creditas.com.br/hc/pt-br",
    rel: "noopener",
    target: device === 'mobile' ? '_self' : '_blank',
    onClick: function onClick() {
      return handleDispatchMenuEvents({
        action: 'inbound links | ajuda',
        label: 'https://ajuda.creditas.com.br/hc/pt-br'
      });
    }
  }, (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0
  }, (0, _core.jsx)(_UiComponents.Typo.Item, typoProps, "Ajuda")))));
};

exports.MainLinks = MainLinks;
MainLinks.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MainLinks"
};